// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.6159a7723',
  revision: '6159a7723',
  branch: 'develop',
  date: 'Fri, 05 Jun 2026 17:56:45 GMT'
};